import { Routes, Route, Navigate } from 'react-router-dom';
import TokenLanding         from '../pages/TokenLanding';
import IdentityVerification from '../pages/IdentityVerification';
import FormAccess           from '../pages/FormAccess';
import ErrorPage            from '../pages/ErrorPage';


export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/access"      element={<TokenLanding />} />
      <Route path="/Access"      element={<TokenLanding />} />
      <Route path="/verify"      element={<IdentityVerification />} />
      <Route path="/form-access" element={<FormAccess />} />      
      <Route path="/error"       element={<ErrorPage />} />
      <Route path="*" element={<Navigate to="/error?reason=NO_TOKEN_PROVIDED" replace />} />
    </Routes>
  );
}
